import { useImmer } from "use-immer";
import { getRACTDetailsApi } from "../apis";
import { errorMessage, successMessage } from "../../../utils";
import { useEffect } from "react";
import { useAlertContext } from "../../../shared";
import { Button, Stack } from "@mui/material";
import { initialAlertState } from "../../../store";
import { PlayOrPauseAllBirthdayCoupon } from "../../BirthdayCouponsV2";

export const useRACT = () => {
  const [state, setState] = useImmer({
    details: null,
    isLoading: true,
    publishing: false,
    unPublishing: false,
  });

  const { setAlert } = useAlertContext();

  useEffect(() => {
    fetchRACTDetails();
  }, []);

  // Function to fetch RACT details from the API
  const fetchRACTDetails = async () => {
    triggerLoading(true);
    try {
      const response = await getRACTDetailsApi();
      const { success, data, message } = response;

      if (success) {
        setState((draft) => {
          draft.details = data;
        });
      } else {
        throw new Error(message);
      }
    } catch (error) {
      const erMessage = error.response?.data?.message || error.message;
      errorMessage(erMessage);
      console.error(error);
    } finally {
      triggerLoading(false);
    }
  };

  const publishOrUnpublishRACT = async ({ status, couponId }) => {
    triggerLoading(true, status);
    try {
      const response = await PlayOrPauseAllBirthdayCoupon(couponId);
      const { success, message } = response;
      if (success) {
        setState((draft) => {
          draft.details.active = draft.details.active === 2 ? 3 : 2;
        });
        successMessage(message);
      } else {
        throw new Error(message);
      }
    } catch (error) {
      const erMessage =
        error.response?.data?.message ||
        error.message ||
        `RACT ${status} is failed`;
      errorMessage(erMessage);
      console.error(error);
    } finally {
      triggerLoading(false, status);
    }
  };

  const triggerLoading = (status, type = null) => {
    setState((draft) => {
      if (["publish", "unpublish"].includes(type)) {
        draft.publishingOrUnpublishing = status;
      } else {
        draft.isLoading = status;
      }
    });
  };

  const handleCloseAlert = () => setAlert(initialAlertState);

  const showAlert = ({ status }) => {
    const type = status.toLowerCase();
    setAlert((draft) => {
      draft.open = true;
      draft.title = `${status} RACT`;
      draft.description = `Are you sure you want to ${type} this RACT?`;

      draft.rowAction = (
        <Stack flexDirection="row" gap="12px">
          <Button
            onClick={() => {
              handleCloseAlert();
            }}
          >
            No
          </Button>
          <Button
            variant="contained"
            onClick={async () => {
              handleCloseAlert();
              await publishOrUnpublishRACT({
                status: type,
                couponId: state.details.id,
              });
            }}
          >
            Yes
          </Button>
        </Stack>
      );
      draft.sx = { width: 425 };
    });
  };

  return { state, showAlert, fetchRACTDetails };
};
